module.exports = __webpack_public_path__ + "static/media/5_r_lamp_60.21_0.47c4e713.png";